/** nav component define */

import template from './template.html';
import './style.less';

export default {
  template
};



/** WEBPACK FOOTER **
 ** ./examples/nav/component.js
 **/